import * as THREE from 'three';
import { markInteractive } from './BaseComponent';

export class LEDComponent extends THREE.Group {
  private lensMaterial: THREE.MeshPhysicalMaterial;
  private glow: THREE.PointLight;
  private halo: THREE.Mesh;

  constructor() {
    super();
    this.name = 'LED';
    this.lensMaterial = new THREE.MeshPhysicalMaterial({
      color: 0x5c0909, emissive: 0x220000, emissiveIntensity: 0.2,
      transparent: true, opacity: 0.88, roughness: 0.22, transmission: 0.16
    });
    const lens = new THREE.Mesh(new THREE.SphereGeometry(0.48, 24, 18, 0, Math.PI * 2, 0, Math.PI * 0.72), this.lensMaterial);
    lens.position.y = 1.05;
    lens.castShadow = true;
    this.add(lens);
    const rim = new THREE.Mesh(new THREE.CylinderGeometry(0.55, 0.55, 0.14, 24), new THREE.MeshStandardMaterial({ color: 0x671313 }));
    rim.position.y = 0.72;
    this.add(rim);
    const leads = new THREE.Mesh(new THREE.CylinderGeometry(0.035, 0.035, 0.8, 8), new THREE.MeshStandardMaterial({ color: 0xc4cbd0, metalness: 0.9 }));
    leads.position.set(-0.18, 0.35, 0);
    this.add(leads, leads.clone());
    this.children[this.children.length - 1].position.x = 0.18;
    this.glow = new THREE.PointLight(0xff2d20, 0, 4.5, 2);
    this.glow.position.y = 1.25;
    this.add(this.glow);
    this.halo = new THREE.Mesh(
      new THREE.SphereGeometry(0.72, 18, 12),
      new THREE.MeshBasicMaterial({ color: 0xff2c24, transparent: true, opacity: 0, depthWrite: false, blending: THREE.AdditiveBlending })
    );
    this.halo.position.y = 1.05;
    this.add(this.halo);
    markInteractive(this, {
      id: 'LED', name: '发光二极管', english: 'Light-emitting Diode', model: '红色 LED · 低电平点亮',
      function: '用亮灭直观显示芯片输出的吸电流状态。',
      connection: 'VCC → LED → R3（约2kΩ）→ 逻辑输出 Y。',
      mistake: 'LED 亮不代表 Y=1；本接法在 Y=0 时点亮。',
      tip: 'Y=0 时输出吸收电流；Y=1 时 LED 两端压差很小。'
    });
  }

  setOn(on: boolean): void {
    this.lensMaterial.color.setHex(on ? 0xff2418 : 0x5c0909);
    this.lensMaterial.emissive.setHex(on ? 0xff1408 : 0x220000);
    this.lensMaterial.emissiveIntensity = on ? 3.2 : 0.2;
    this.glow.intensity = on ? 2.2 : 0;
    (this.halo.material as THREE.MeshBasicMaterial).opacity = on ? 0.14 : 0;
    this.userData.meta.model = on ? '当前：亮（Y=0）' : '当前：灭（Y=1）';
  }
}
